import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment as env } from '@env/environment';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class GoogleMapsApiService extends BaseService {
  private http = inject(HttpClient);
  constructor() {
    super();
  }

  public loadGoogleMapsApi(): Observable<object> {
    return this.http.jsonp(
      `https://maps.googleapis.com/maps/api/js?key=${env.googleApiKey}&libraries=places`,
      'callback',
    );
  }
}
